import { useQuery } from "@tanstack/react-query";
import useApiLeaderboard from "./useLeaderboard";

const useLeaderboardListCategories = () => {
    const { listCategories } = useApiLeaderboard();

    return useQuery({
        queryKey: ["categories"],
        queryFn: () => listCategories(),
        staleTime: 1000 * 60 * 60 * 24,
        placeholderData: (previousData) => previousData,
    });
}

export default useLeaderboardListCategories;